import { combineReducers } from 'redux';

import configuration from './configuration/reducer';

export default combineReducers({ configuration });



// WEBPACK FOOTER //
// ./src/pages/verificationconfiguration/state/reducer.js